import React from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import TableHead from "@material-ui/core/TableHead/index";
import TableRow from "@material-ui/core/TableRow/index";
import TableCell from "@material-ui/core/TableCell/index";
import TableBody from "@material-ui/core/TableBody/index";
import Table from "@material-ui/core/Table/index";
import { green } from "@material-ui/core/colors/index";
import { getTimeStr } from "../../utils/helpers";

import { requiredFields } from "../data/import/fields";

const useStyles = makeStyles(theme => ({
  table: {
    fontSize: "13px !important",
    marginTop: theme.spacing(1.25)
  },
  tableCell: {
    padding: "4px 8px !important",
    fontSize: "12px !important",
    borderColor: "rgba(255, 255, 255, 0.22) !important",
    fontWeight: "normal !important"
  },
  tableBodyCell: {
    fontSize: "10px !important"
  },
  noBorderBottom: {
    borderBottom: "none !important"
  },
  validRow: {
    backgroundColor: green[100]
  },
  invalidRow: {
    backgroundColor: "#FFC6CC"
  }
}));

function DataTable({ tableData, validRows, invalidRows, services = false }) {
  const classes = useStyles();

  // handle stop upload.
  let finalTableData = tableData;
  if (services) {
    finalTableData = finalTableData.map(row => {
      return {
        type: row.type,
        name: row.information ? row.information.name : null,
        street: row.information ? row.information.street : null,
        city: row.information ? row.information.city : null,
        postal_code: row.information ? row.information.zipcode : null,
        country_code: row.information ? row.information.country : null,
        lat: row.address ? row.address.lat : null,
        lng: row.address ? row.address.lng : null,
        duration: row.duration,
        from: row.time_windows
          ? getTimeStr(row.time_windows[0].earliest)
          : null,
        to: row.time_windows ? getTimeStr(row.time_windows[0].latest) : null,
        email: row.information ? row.information.email : null,

        phone: row.information ? row.information.recipient_phone : null,
        priority: row.priority === 1 ? "Yes" : null,
        pod_signature:
          row.requirements && row.requirements.signature ? "Yes" : null,
        pod_age:
          row.requirements && row.requirements.age_verification ? "Yes" : null,
        pod_photo: row.requirements && row.requirements.picture ? "Yes" : null,
        delivery_note: row.information ? row.information.notes : null,
        vehicle_tags: row.tags
          ?.filter(tag => tag.type === "VEHICLE")
          .map(el => el.name)
          .join("; "),
        driver_tags: row.tags
          ?.filter(tag => tag.type === "DRIVER")
          .map(el => el.name)
          .join("; "),
        unit_count: row.quantity,
        unit_weight: row.weight || null,
        unit_volume: row.volume || null,
        unit_id: row.units && row.units[0] ? row.units[0].name : null,
        unit_note: row.units && row.units[0] ? row.units[0].note : null,
        tracking_id: row.tracking ? row.tracking.id : null
      };
    });
    services = false;
  }

  return (
    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          {(services
            ? Object.keys(finalTableData.find(el => el.information).information)
            : Object.keys(finalTableData[0])
          ).map((field, j) => (
            <TableCell key={j} className={classes.tableCell}>
              {field}
              {requiredFields[field] ? "*" : ""}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {finalTableData.map((obj, j) => (
          <TableRow
            key={j}
            className={`${validRows && classes.validRow} ${
              invalidRows && classes.invalidRow
            }`}
          >
            {(services
              ? obj.information && Object.keys(obj.information)
              : Object.keys(finalTableData[0])
            ).map((data, k) => (
              <TableCell
                key={k}
                className={`${classes.tableCell} ${classes.tableBodyCell} ${
                  j === finalTableData.length - 1
                    ? classes.noBorderBottom
                    : null
                }`}
              >
                {services
                  ? obj.information[data]
                    ? obj.information[data]
                    : "-"
                  : obj[data] || "-"}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default DataTable;
